import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { company } from '../data/company';
export function MobileCallBar() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-brass-dark bg-brass px-4 py-3 lg:hidden" data-id="element-154" data-mp="2sbbi2vte0ar7">
      <a href={company.phoneHref} className="flex items-center justify-center gap-2.5 font-display text-base font-bold text-ink-950" data-id="element-155" data-mp="2ecbzo5wgws3h">
        <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-156" data-mp="24mk1z2t2nius" />
        Appeler {company.phone}
      </a>
    </div>;
}